import { enableProdMode } from '@angular/core';
import '@upmc-healthplan-npm/ods-wc';
import { configurationSubject } from './app/shared/utils/environment-resolver';
import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app/app.component';
import { appConfig } from 'app/app.config';

let configurationEvent = document.createEvent('Event');
configurationEvent.initEvent('config.set', true, true);
const apiConfig = localStorage.getItem('environment');
let env = apiConfig ? JSON.parse(apiConfig).environment || 'dev' : 'dev';

fetch('./config/config.' + env + '.json')
  .then((result) => {
    return result.json();
  })
  .then(
    (data) => {
      (window as { [key: string]: any })['environment'] = data;
      document.dispatchEvent(configurationEvent);
    },
    (error) => {
      console.log('error ', error);
      window.location.reload();
    },
  );

if (!(window as { [key: string]: any })['environment']) {
  document.addEventListener('config.set', function (e) {
    if ((window as { [key: string]: any })['environment'].production) {
      enableProdMode();
    }

    configurationSubject.next((window as { [key: string]: any })['environment']);
    (window as { [key: string]: any })['environment'] = undefined;
    bootstrapApplication(AppComponent, appConfig).catch((err) => console.log(err));
  });
}
